// Field-level selectors for the price-matrix container.
export const selectSiteSettings = (state) => state.common.siteSettings;
export const selectUserId = (state) => state.common.userId;
export const selectAlternativeHotels = (state) => state.alternativeHotels.hotels;
export const selectAlternativeHotelsLabels = (state) => state.labels.alternativeHotels;
export const selectAppStatus = (state) => state.appStatus;
export const selectError = (state) => state.error;
export const selectHotelData = (state) => state.hotelData;
export const selectLabels = (state) => state.labels.priceMatrix;
export const selectMessage = (state) => state.message;
export const selectSearchInformation = (state) => state.searchInformation;
export const selectSummaryReturnLink = (state) => state.combinationInfo?.summaryReturnLink;
export const selectTransportData = (state) => state.transportData;
